import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handlePost } from '../../../utils/AxiosUtil';
import axios from 'axios';
import MyAutocomplete from '../../common/inputfields/MyAutocomplete';
import * as util from '../../../utils/EnumMapping';
import ErrorAwareTextField from '../../common/inputfields/ErrorAwareTextField';

class CloseAndLinkToPartner extends Component {
    state = {
        errors: new Map(),
        selectedCustomer: {},
        comment: ''
    }
    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = this.props.path;
        const requestObject = {
            "transactionPrivateId": this.props.row.privateId,
            "partnerPrivateId": this.state.selectedCustomer.value.privateId,
            "partnerType": this.state.selectedCustomer.value.partnerType,
            "comment": this.state.comment,
        };
        // console.log(requestObject);
        handlePost(path, requestObject, this);
    };

    promiseCustomerOptions = async () => {
        console.log("promiseCustomerOptions");
        const response = await axios.get('/api/bank/partners')
        const renamedCustomers = [];
        response.data.map((partner) =>
            renamedCustomers.push({
                label: util.getLabel(util.partnerTypes, partner.partnerType) + ' - ' + partner.name,
                value: partner,
            }));
        return renamedCustomers;
    };

    handleCustomerSelected = (e, v, this2) => {
        if (v && v.inputValue) {
        } else {
            this2.setState({ selectedCustomer: v })
        }
    }

    render() {
        return (
            //todo: list proposed?
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                <div className='input-group'>
                    <MyAutocomplete
                        value={this.state.selectedCustomer}
                        getOptions={this.promiseCustomerOptions}
                        onChange={(e, v) => this.handleCustomerSelected(e, v, this)}
                        label={'Megnevezés'}
                    />
                </div>
                <div className='input-group'>
                    <ErrorAwareTextField
                        name="comment"
                        label="Lezárás megjegyzés"
                        value={this.state.comment}
                        onChange={e => this.setState({ comment: e.target.value })}
                    />
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás és lezárás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(CloseAndLinkToPartner);
